import { handleErrorWithToastUnlessUnauthorised, makePostRequest } from '../apiHelpers';
import { ENDPOINTS } from '../constants';
import { isLoading } from '../../Loading/isLoading';

const type = ENDPOINTS.API.TEMPLATES_UPDATE;

export const apiTemplateUpdate = template => async (dispatch, getState) => {
    isLoading(dispatch, type, true, {});
    makePostRequest(['template'], undefined, template)
        .then(({ data }) => {
            dispatch({ type, data });
            isLoading(dispatch, type, false, {});
        })
        .catch(error => handleErrorWithToastUnlessUnauthorised(dispatch, getState, error, type, 'Templates'));
};
